import { SUBSCRIPTION_STATUS_ENUM } from "@antipartido-inc/contracts-ifaces"

export default {
  personalData: {
    title: "Datos personales",
    fields: {
      name: "Nombre",
      surnames: "Apellidos",
      address: "Domicilio",
      email: "Email",
      phone: "Teléfono",
      birthDate: "Fecha de nacimiento",
      curp: "CURP",
    },
  },
  credentialInfo: {
    title: "Información de la credencial",
    fields: {
      voterKey: "Clave de elector",
      section: "Sección",
      validity: "Vigencia",
    },
    modify: "Modificar",
    needModify: {
      title: "¿Necesitas modificar tu INE?",
      description:
        "Si necesitas modificar cualquier dato del INE (cambio de municipio, renovación por vigencia, robo o pérdida) tendrás que:",
      bullet1: "Realizar dicho trámite en la",
      officialPage: "página oficial",
      bullet2:
        'Una vez realizado el cambio y obtenido el INE con los datos actualizados, haz click en el botón de "validar".',
    },
    validate: {
      title: "Validar",
      description:
        "Una vez realizado el cambio y obtenida la nueva credencial del INE con los datos actualizados, haz click en el siguiente botón",
      button: "Validar",
    },
    validateModal: {
      title: "Validar INE",
      message:
        "Vas a iniciar el proceso de verificación de tu nueva credencial INE. Serás redirigido al servicio de verificación para validar tu identidad.",
      confirm: "Sí, validar",
      cancel: "Cancelar",
      redirecting: "Redirigiendo...",
    },
  },
  verifications: {
    title: "Verificaciones",
    kyc: "KYC",
    wallet: "Wallet",
    subscription: "Suscripción",
    subscriptionActive: "Activa",
    subscriptionInactive: "Inactiva",
  },
  walletSection: {
    title: "Cuenta",
    viewInExplorer: "Ver en el explorador",
    noWallet: "No hay wallet conectada",
    poweredBy: "Powered by HumanWallet, developed",
    poweredByLink: "by Tutellus",
  },
  themeSection: {
    light: "Modo oscuro",
    dark: "Modo claro",
  },
  userSection: {
    title: "Usuario",
    wallet: {
      infoTitle: "No compartas tu dirección",
      infoMessage: "Tu dirección solo la conoces tú. No la compartas con nadie, podrían ver tus votos",
    },
    transactions: {
      title: "Transacciones",
      infoTitle: "Detalle de la transacción",
      infoMessage:
        "Haz click en la transacción que quieras y te redirigiremos para que veas el detalle de la transacción en la blockchain",
      empty: "No hay transacciones registradas",
    },
  },
  subscriptionSection: {
    title: "Suscripción",
  },
  notificationsSection: {
    title: "Notificaciones",
  },
  subscription: {
    type: "Anual",
    subscriptionType: "Tipo de suscripción",
    price: "Precio",
    status: "Estado",
    statuses: {
      [SUBSCRIPTION_STATUS_ENUM.PENDING]: "Pendiente",
      [SUBSCRIPTION_STATUS_ENUM.APPROVAL_PENDING]: "Aprobación Pendiente",
      [SUBSCRIPTION_STATUS_ENUM.ACTIVE]: "Activa",
      [SUBSCRIPTION_STATUS_ENUM.SUSPENDED]: "Suspendida",
      [SUBSCRIPTION_STATUS_ENUM.CANCELLED]: "Cancelada",
      [SUBSCRIPTION_STATUS_ENUM.EXPIRED]: "Expirada",
    },
    timeRemaining: "Tiempo restante",
    days: "días",
    autoRenewal: "Renovación automática",
    yes: "Si",
    no: "No",
    startDate: "Fecha de inicio",
    endDate: "Fecha de fin",
    nextBillingDate: "Próxima fecha de cobro",
    cancelSubscription: "Cancelar suscripción",
    getSubscription: "Obtener suscripción",
    getButton: "OBTENER",
    reactivateButton: "Activar renovación",
    continue: "Continuar",
    loading: "Cargando...",
    noSubscription: "No tienes ninguna suscripción activa",
    confirmCancel: {
      title: "¿Estás seguro?",
      message: "Si cancelas tu suscripción no se renovará, por lo que cuando se acabe no podrás seguir votando",
      confirm: "Cancelar suscripción",
      cancel: "Volver",
    },
    checkout: {
      title: "Finaliza tu compra",
      summary: "Resumen",
      selectPayment: "Selecciona tu forma de pago",
      mercadopago: "Mercado Pago",
      mercadopagoDescription: "Paga de forma segura con Mercado Pago",
      card: "Tarjeta",
      cardDescription: "Paga de forma segura con tu tarjeta de débito o crédito",
      paypal: "PayPal",
      paypalDescription: "Paga de forma segura con tu cuenta de PayPal",
      payButton: "PAGAR",
      renewalNote: "La suscripción se renovará automáticamente, pero podrás cancelarla siempre que quieras.",
    },
    reviewer: {
      status: "Activa (cuenta de revisión)",
    },
    pendingApproval: {
      title: "Tu pago está pendiente",
      message:
        "Iniciaste un pago con {{provider}} pero no se completó. Puedes continuarlo desde donde lo dejaste o cancelarlo y elegir otro método.",
      continueButton: "Continuar pago",
      cancelButton: "Cancelar y empezar de nuevo",
    },
    error: "Error al cargar la suscripción",
    cancelError: "Error al cancelar la suscripción",
    cancelSuccess: "Suscripción cancelada correctamente",
  },
  participationSection: {
    title: "Participación",
    navLabel: "Rol de participación",
    noRole: "Sin rol asignado",
    roles: {
      REPRESENTATIVE: "Representante",
      NOTARIO_CIUDADANO: "Notario Electoral Ciudadano",
      NONE: "Ninguna",
    },
  },
  faqSection: {
    title: "Preguntas frecuentes",
  },
  contact: {
    title: "¿Necesitas ayuda?",
    button: "Contacto",
  },
  disconnect: "Salir",
  disconnectModal: {
    title: "Cerrar sesión",
    message: "Vas a cerrar la sesión con el correo",
    confirm: "Sí, continuar",
    cancel: "Cancelar",
  },
}
